import { db } from "../firebase";
import Firebase from "firebase";

// Example update doc
export function updateExample(doc_id_1, doc_id_2, data, callback) {
  let docRef = db.collection("example").doc(doc_id_1).collection("example").doc(doc_id_2);

  docRef
    .update({
      example: data,
    })
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(error);
    });
}

export function updateExerciseAurum(content, doc_id, callback) {
  debugger
  let docRef = db.collection("exercises").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      debugger
      callback(true);
    })
    .catch((error) => {
      debugger
      console.log("update aurum exercise",error.message)
      callback(false);
    });
}

export function updateCoach(content, doc_id, callback) {
  let docRef = db.collection("coaches").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateClients(content, doc_id, callback) {
  let docRef = db.collection("clients").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateProgramAurum(content, doc_id, callback) {
  let docRef = db.collection("programs").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateProgramWorkoutAurum(content, doc_id, workoutID, callback) {
  let docRef = db.collection("programs").doc(doc_id).collection('workouts').doc(workoutID);

  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateExerciseCoach(uid, content, doc_id, callback) {
  let docRef = db.collection("coaches").doc(uid).collection("exercises").doc(doc_id);

  docRef
    .update(content)
    .then((e) => {
      // console.log("debug updateexecise",callback,e)
      // callback(e);
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateProgramCoach(uid, content, doc_id, callback) {
  let docRef = db.collection("coaches").doc(uid).collection("programs").doc(doc_id);
  console.log("content",{uid:uid,content:content,doc_id:doc_id})
  debugger
  docRef
    .update(content)
    .then(() => {
      debugger
      callback(true);
    })
    .catch((error) => {
      debugger
      console.log("error message",error.message)
      callback(false);
    });
}

export function updateProgramWorkoutCoach(uid, content, doc_id, workoutID, callback) {
  debugger
  let docRef = db.collection("coaches").doc(uid).collection("programs").doc(doc_id).collection('workouts').doc(workoutID);
  console.log("updateprogrameworkout tocaoch",{uid:uid,doc_id:doc_id,workoutID:workoutID})
  docRef
    .update(content)
    .then(() => {
      debugger
      callback(true);
    })
    .catch((error) => {
      debugger
      callback(false);
      console.log("error",error.message)
    });
}

export function updateWorkoutAurum(content, doc_id, callback) {
  // debugger
  // console.log("contents",content,doc_id)
  let docRef = db.collection("workouts").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      // debugger
      callback(true);
    })
    .catch((error) => {
      // debugger
      callback(false);
      // console.log("error upd workout aurum",error.message)
    });
}

export function updateWorkoutCoach(uid, content, doc_id, callback) {
  debugger
  let docRef = db.collection("coaches").doc(uid).collection("workouts").doc(doc_id);

  docRef
    .update(content)
    .then(() => {
      debugger
      callback(true);
    })
    .catch((error) => {
      debugger
      console.log("error",error)
      callback(false);
    });
}

export function updateMealplanAurum(content, doc_id, callback) {
  let docRef = db.collection("mealplans").doc(doc_id);
  
  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateMealplanCoach(uid, content, doc_id, callback) {
  let docRef = db.collection("coaches").doc(uid).collection("mealplans").doc(doc_id);
  console.log(content);
  docRef
    .update(content)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function updateFormItemOrderAurum(doc_id, sub_doc_id, content, callback) {
  let docRef;

  if (sub_doc_id) {
    docRef = db.collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id);
  } else {
    docRef = db.collection("forms").doc(doc_id);
  }

  docRef.get().then((doc) => {
    let _form = doc.data().form;
    let _found = _form.filter((e) => !content.find((a) => e.id === a.id));
    let _content = content.concat(_found);
    docRef
      .set({ form: _content }, { merge: true })
      .then(() => {
        callback(true);
      })
      .catch((error) => {
        callback(false);
      });
  });
}

export function updateFormItemOrderCoach(uid, doc_id, sub_doc_id, content, callback) {
  let docRef;

  if (sub_doc_id) {
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id);
  } else {
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id);
  }

  docRef.get().then((doc) => {
    let _form = doc.data().form;
    let _found = _form.filter((e) => !content.find((a) => e.id === a.id));
    let _content = content.concat(_found);
    docRef
      .set({ form: _content }, { merge: true })
      .then(() => {
        callback(true);
      })
      .catch((error) => {
        callback(false);
      });
  });
}

export function updateFormItemAurum(doc_id, sub_doc_id, content, callback) {
  let docRef;

  if (sub_doc_id) {
    docRef = db.collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id);
  } else {
    docRef = db.collection("forms").doc(doc_id);
  }

  docRef.get().then((doc) => {
    let _form = doc.data().form;
    let _found = _form.findIndex((e) => e.id === content.id);
    if (_found !== -1) {
      _form.splice(_found, 1, content);
      docRef
        .set({ form: _form }, { merge: true })
        .then(() => {
          callback(true);
        })
        .catch((error) => {
          callback(false);
        });
    } else {
      callback(false);
    }
  });
}

export function updateFormItemCoach(uid, doc_id, sub_doc_id, content, callback) {
  let docRef;

  if (sub_doc_id) {
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id);
  } else {
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id);
  }

  docRef.get().then((doc) => {
    let _form = doc.data().form;
    let _found = _form.findIndex((e) => e.id === content.id);
    if (_found !== -1) {
      _form.splice(_found, 1, content);
      docRef
        .set({ form: _form }, { merge: true })
        .then(() => {
          callback(true);
        })
        .catch((error) => {
          callback(false);
        });
    } else {
      callback(false);
    }
  });
}

export function updateReadState(last_message_id, client_id) {
  let docRef = db.collection("clients").doc(client_id).collection("Chat").doc(last_message_id);
  docRef.update({ read: true }).then(() => {});
}

export function updatePrograms(client_id, programs, callback) {
  let docRef = db.collection("clients").doc(client_id);
  docRef.update({ programs: programs }).then(() => { callback(true); });
}

export function updateWorkouts(client_id, workouts, callback) {
  let docRef = db.collection("clients").doc(client_id);
  docRef.update({ workouts: workouts }).then(() => { callback(true); });
}

export function updateMealplans(client_id, mealplans, callback) {
  let docRef = db.collection("clients").doc(client_id);
  docRef.update({ mealplans: mealplans }).then(() => { callback(true); });
}

export function updateIsTyping(client_id, bool) {
  let docRef = db.collection("clients").doc(client_id).collection("Chat").doc("is_typing");
  docRef.set({ coach_typing: bool }, { merge: true }).then(() => {});
}
